/* eslint-disable */
module.exports =
  process.env.NODE_ENV === 'test'
    ? require('./src/index.js')
    : require('./lib/index.js');
